module.exports = __webpack_public_path__ + "img/purchase_egg_infographic.83a0c410.svg";